import { render } from "./TilePointer.vue?vue&type=template&id=6a7fcba1&scoped=true"
import script from "./TilePointer.vue?vue&type=script&lang=js"
export * from "./TilePointer.vue?vue&type=script&lang=js"

import "./TilePointer.vue?vue&type=style&index=0&id=6a7fcba1&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7fcba1"]])

export default __exports__